// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Register_register-container__\\+dgwP {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #f0f2f5;
  padding: 24px;
}

.Register_register-card__IgqU8 {
  max-width: 520px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    width: 40%;
    display: block;
    margin-left: auto;
    margin-right: auto;
}

.Register_register-header__OZ8Ia {
  text-align: center;
  margin-bottom: 24px;
}

.Register_register-title__xQQP6 {
  margin-bottom: 8px !important;
  color: #1890ff;
}

.Register_register-form__KFnYd {
  margin-top: 24px;
}

.Register_register-footer__mrEwh {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  gap: 8px;
}

/* Адаптивные стили */
@media (max-width: 768px) {
  .Register_register-container__\\+dgwP {
    padding: 16px;
  }

  .Register_register-card__IgqU8 {
    box-shadow: none;
    border: 1px solid #f0f0f0;
  }
}

/* Стили для полей ввода */
.Register_ant-input-affix-wrapper__NDwUj,
.Register_ant-input__DxwCp,
.Register_ant-select-selector__B6SMf {
  border-radius: 4px !important;
}

.Register_ant-form-item-label__kL1B4 label {
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/styles/Register.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;IACvC,UAAU;IACV,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,QAAQ;AACV;;AAEA,qBAAqB;AACrB;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;AACF;;AAEA,0BAA0B;AAC1B;;;EAGE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".register-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: #f0f2f5;\n  padding: 24px;\n}\n\n.register-card {\n  max-width: 520px;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    width: 40%;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.register-header {\n  text-align: center;\n  margin-bottom: 24px;\n}\n\n.register-title {\n  margin-bottom: 8px !important;\n  color: #1890ff;\n}\n\n.register-form {\n  margin-top: 24px;\n}\n\n.register-footer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 16px;\n  gap: 8px;\n}\n\n/* Адаптивные стили */\n@media (max-width: 768px) {\n  .register-container {\n    padding: 16px;\n  }\n\n  .register-card {\n    box-shadow: none;\n    border: 1px solid #f0f0f0;\n  }\n}\n\n/* Стили для полей ввода */\n.ant-input-affix-wrapper,\n.ant-input,\n.ant-select-selector {\n  border-radius: 4px !important;\n}\n\n.ant-form-item-label label {\n  font-weight: 500;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"register-container": `Register_register-container__+dgwP`,
	"register-card": `Register_register-card__IgqU8`,
	"register-header": `Register_register-header__OZ8Ia`,
	"register-title": `Register_register-title__xQQP6`,
	"register-form": `Register_register-form__KFnYd`,
	"register-footer": `Register_register-footer__mrEwh`,
	"ant-input-affix-wrapper": `Register_ant-input-affix-wrapper__NDwUj`,
	"ant-input": `Register_ant-input__DxwCp`,
	"ant-select-selector": `Register_ant-select-selector__B6SMf`,
	"ant-form-item-label": `Register_ant-form-item-label__kL1B4`
};
export default ___CSS_LOADER_EXPORT___;
